import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-4 mb-5 mx-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_TextFieldGroup = _resolveComponent("TextFieldGroup")!
  const _component_ValidationProvider = _resolveComponent("ValidationProvider")!
  const _component_BCol = _resolveComponent("BCol")!
  const _component_BRow = _resolveComponent("BRow")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_BForm = _resolveComponent("BForm")!
  const _component_CustomValidationObserver = _resolveComponent("CustomValidationObserver")!
  const _component_BlockBack = _resolveComponent("BlockBack")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, null, {
      left: _withCtx(() => [
        _createVNode(_component_FeatherIcon, {
          icon: "chevron-left",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      アカウント認証\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_CustomValidationObserver, {
        ref: "form",
        tag: "div",
        class: "w-100"
      }, {
        default: _withCtx(({ handleSubmit }) => [
          _createVNode(_component_BForm, null, {
            default: _withCtx(() => [
              _createVNode(_component_ValidationProvider, {
                vid: "phoneNumber",
                name: "電話番号",
                rules: "required",
                value: _ctx.phoneNumberWithHyphen
              }, {
                default: _withCtx((validationState) => [
                  _createVNode(_component_TextFieldGroup, {
                    value: _ctx.phoneNumberWithHyphen,
                    label: "設定した電話番号",
                    disabled: "",
                    class: "mb-3",
                    "validation-state": validationState
                  }, null, 8, ["value", "validation-state"])
                ]),
                _: 1
              }, 8, ["value"]),
              _createTextVNode(),
              _createVNode(_component_ValidationProvider, {
                vid: "email",
                name: "メールアドレス",
                rules: "required|email",
                modelValue: _ctx.email,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event))
              }, {
                default: _withCtx((validationState) => [
                  _createVNode(_component_TextFieldGroup, {
                    modelValue: _ctx.email,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
                    label: "メールアドレス",
                    appLabelText: "必須",
                    class: "mb-3",
                    "validation-state": validationState
                  }, null, 8, ["modelValue", "validation-state"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createTextVNode(),
              _createVNode(_component_BRow, { class: "mx-n2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_BCol, { class: "px-2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ValidationProvider, {
                        name: "名前（姓）",
                        vid: "lastName",
                        rules: "required",
                        modelValue: _ctx.lastName,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.lastName) = $event))
                      }, {
                        default: _withCtx((validationState) => [
                          _createVNode(_component_TextFieldGroup, {
                            modelValue: _ctx.lastName,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.lastName) = $event)),
                            label: "名前",
                            appLabelText: "必須",
                            placeholder: "介助",
                            type: "text",
                            class: "mb-3",
                            "validation-state": validationState
                          }, null, 8, ["modelValue", "validation-state"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ], undefined, true),
                    _: 1
                  }),
                  _createTextVNode(),
                  _createVNode(_component_BCol, { class: "px-2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ValidationProvider, {
                        name: "名前（名）",
                        vid: "firstName",
                        rules: "required",
                        modelValue: _ctx.firstName,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.firstName) = $event))
                      }, {
                        default: _withCtx((validationState) => [
                          _createVNode(_component_TextFieldGroup, {
                            modelValue: _ctx.firstName,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.firstName) = $event)),
                            type: "text",
                            placeholder: "太郎",
                            class: "mb-3 mt-4 pt-2",
                            "validation-state": validationState
                          }, null, 8, ["modelValue", "validation-state"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              }),
              _createTextVNode(),
              _createVNode(_component_BRow, { class: "mx-n2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_BCol, { class: "px-2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ValidationProvider, {
                        name: "フリガナ(カタカナ)(姓)",
                        vid: "lastNameKana",
                        rules: "required|hankaku_kana",
                        modelValue: _ctx.lastNameKana,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.lastNameKana) = $event))
                      }, {
                        default: _withCtx((validationState) => [
                          _createVNode(_component_TextFieldGroup, {
                            modelValue: _ctx.lastNameKana,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.lastNameKana) = $event)),
                            label: "フリガナ",
                            appLabelText: "必須",
                            placeholder: "カイテク",
                            type: "text",
                            class: "mb-3",
                            "validation-state": validationState,
                            onBlur: () => _ctx.onBlurLastNameKana(validationState.handleChange)
                          }, null, 8, ["modelValue", "validation-state", "onBlur"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ], undefined, true),
                    _: 1
                  }),
                  _createTextVNode(),
                  _createVNode(_component_BCol, { class: "px-2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ValidationProvider, {
                        name: "フリガナ(カタカナ)(名)",
                        vid: "firstNameKana",
                        rules: "required|hankaku_kana",
                        modelValue: _ctx.firstNameKana,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.firstNameKana) = $event))
                      }, {
                        default: _withCtx((validationState) => [
                          _createVNode(_component_TextFieldGroup, {
                            modelValue: _ctx.firstNameKana,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.firstNameKana) = $event)),
                            type: "text",
                            placeholder: "タロウ",
                            class: "mb-3 mt-4 pt-2",
                            "validation-state": validationState,
                            onBlur: 
                    () => _ctx.onBlurFirstNameKana(validationState.handleChange)
                  
                          }, null, 8, ["modelValue", "validation-state", "onBlur"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              }),
              _createTextVNode(),
              _createVNode(_component_ValidationProvider, {
                vid: "birthDate",
                name: "生年月日",
                rules: "required",
                modelValue: _ctx.birthDate,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.birthDate) = $event))
              }, {
                default: _withCtx((validationState) => [
                  _createVNode(_component_TextFieldGroup, {
                    modelValue: _ctx.birthDate,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.birthDate) = $event)),
                    type: "date",
                    label: "生年月日",
                    appLabelText: "必須",
                    class: "mb-4",
                    "validation-state": validationState
                  }, null, 8, ["modelValue", "validation-state"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createTextVNode(),
              _createVNode(_component_AppButton, {
                block: "",
                onClick: ($event: any) => (handleSubmit(_ctx.onClickAuth))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("\n            認証する\n          ")
                ], undefined, true),
                _: 2
              }, 1032, ["onClick"])
            ], undefined, true),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 512)
    ]),
    _createTextVNode(),
    _createVNode(_component_BlockBack)
  ]))
}